import { c as _c } from "react/compiler-runtime";
import type { FieldValues } from 'react-hook-form';
import useFormErrorMessage from '../ActionForm/useFormErrorMessage';
import { ErrorMessageProps } from './types';
import ErrorMessageText from './ErrorMessageText';
function ErrorMessage(t0) {
  const $ = _c(4);
  const {
    name,
    className
  } = t0;
  const error = useFormErrorMessage(name);
  let t1;
  if ($[0] !== className || $[1] !== error || $[2] !== name) {
    t1 = <ErrorMessageText name={name} className={className}>{error}</ErrorMessageText>;
    $[0] = className;
    $[1] = error;
    $[2] = name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default ErrorMessage;